'use client'

import { Field, FieldError, FieldLabel } from '@ui/base/field'
import { Input } from '@ui/base/input'
import { useFormContext } from 'react-hook-form'

import { type FulfillmentFormValues } from '../model/types'
import { FormBlock } from './form-block'
import { LocationsField } from './locations-field'
import { RequiredMark } from './required-mark'

/** Первый шаг: кто вы и откуда отгружаете. */
export const OrganizationStep = () => {
  const {
    register,
    trigger,
    formState: { errors },
  } = useFormContext<FulfillmentFormValues>()
  const innField = register('inn')

  return (
    <>
      <FormBlock title="Организация">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field data-invalid={Boolean(errors.name?.message)}>
            <FieldLabel htmlFor="fulfillment-name">
              Название фулфилмента <RequiredMark />
            </FieldLabel>
            <Input
              id="fulfillment-name"
              placeholder="Например, ФФ Восток"
              aria-invalid={Boolean(errors.name?.message)}
              aria-describedby={errors.name?.message ? 'fulfillment-name-error' : undefined}
              {...register('name')}
            />
            <FieldError id="fulfillment-name-error">{errors.name?.message}</FieldError>
          </Field>
          <Field data-invalid={Boolean(errors.inn?.message)}>
            <FieldLabel htmlFor="fulfillment-inn">
              ИНН <RequiredMark />
            </FieldLabel>
            <Input
              id="fulfillment-inn"
              inputMode="numeric"
              placeholder="10 или 12 цифр"
              aria-invalid={Boolean(errors.inn?.message)}
              aria-describedby={errors.inn?.message ? 'fulfillment-inn-error' : undefined}
              {...innField}
              onChange={async (event) => {
                await innField.onChange(event)
                // Ошибку показываем после ухода из поля, но убираем сразу, как только ИНН стал верным:
                // иначе красная подпись висит, пока пользователь снова не уйдёт из поля.
                if (errors.inn) {
                  await trigger('inn')
                }
              }}
            />
            <FieldError id="fulfillment-inn-error">{errors.inn?.message}</FieldError>
          </Field>
        </div>
      </FormBlock>

      <FormBlock
        title="Где находится склад"
        description="Города, куда продавец привозит товар. По ним карточка попадает в подборки городов каталога."
      >
        <LocationsField />
      </FormBlock>
    </>
  )
}
